import React from "react";
import { ArticleBar } from "../components/faq";
import SEO from "../components/head";
import Layout from "../components/layout";
import { StyledPrimaryHeader } from "../components/styled";
import { EventProvider } from "../context/EventProvider";
import { StrapiSourceData } from "../interfaces/strapi";

const Venue = ({ pageContext }: { pageContext: StrapiSourceData }) => {
  const { event } = pageContext;
  const {
    location,
    postalCode,
    addressRegion,
    streetAddress,
    addressLocality,
    embed: { data },
  } = event.addresses[0];

  return (
    <EventProvider data={pageContext} >
      <Layout className="page__venue">
        <ArticleBar className="page-container">
          <div className="venue-container">
            <div className="venue-content-container">
              <StyledPrimaryHeader>Venue</StyledPrimaryHeader>
              <div>
                <h2 style={{ textTransform: "uppercase" }}>{location}</h2>
                <span>
                  {streetAddress}, {addressLocality},{" "}
                  {addressRegion} {postalCode}
                </span>

                <h3>Getting There</h3>
                <div>
                  <h4>Parking</h4>
                  <p>$21/per day in parking garage located immediately underneath the HQ2 Event's Center (510 14th St S). There are 2 entrances to the parking garage, one located on Elm Street next to the WAS17 loading dock and the other located on 13th Street between Elm and Eads. Take the elevator to the first floor.</p>
                </div>
                <div>
                  <h4>Metro</h4>
                  <p>Pentagon City Metro (Blue/Yellow lines) is a 9 minute, flat walk.</p>
                </div>
              </div>
            </div>
            <div className="maps-container">
              <iframe
                src={data.embed}
                width="501px"
                height="525px"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </ArticleBar>
      </Layout>
    </EventProvider>
  );
};

export default Venue;

export const Head = ({ pageContext }: { pageContext: StrapiSourceData }) => {
  return <EventProvider data={pageContext} ><SEO title="Location" /></EventProvider>;
};
